import { graphql } from '@/gql'

export const DeletePaymentRequestMutation = graphql(/* GraphQL */ `
  mutation deletePaymentRequestMutation($input: DeletePaymentRequestInput!) {
    deletePaymentRequest(input: $input) {
      id
    }
  }
`)
